import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Style } from '../../models/Style';
import { StyleService } from '../../services/style.service';
import { environment } from '../../../environments/environment';

interface StyleImage {
  image: string;
  style: Style;
}

@Component({
  selector: 'mpf-map-config-style',
  templateUrl: './map-config-style.component.html',
  styleUrls: ['./map-config-style.component.scss']
})
export class MapConfigStyleComponent {
  @Input() style: Style;
  @Output() styleChange = new EventEmitter<Style>();

  private _styles: Style[];

  shadowImg: string = require('../../../assets/img/selector-shadow.png');
  styleImages: StyleImage[] = [];

  constructor(private styleService: StyleService) {
    this.styles = styleService.list();
  }

  set styles(styles: Style[]) {
    this._styles = styles;

    this.styleImages = styles.map(style => ({
      image: require(`../../../assets/img/${style.name}-selector.png`),
      style
    }));
  }

  setStyle(style: Style) {
    this.style = style;
    this.styleChange.emit(style);
  }

  compareStyles(styleA: Style, styleB: Style) {
    return styleA && styleB && styleA.id === styleB.id;
  }
}



// WEBPACK FOOTER //
// /vercel/workpath0/src/app/components/map-config-style/map-config-style.component.ts